import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatCommonModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule
} from '@angular/material';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// COMPONENTS
import {BySiteTypeComponent} from './components/by-site-type/by-site-type.component';
import {FrontendVersionComponent} from './components/frontend-version/frontend-version.component';
import {BackendVersionComponent} from './components/backend-version/backend-version.component';
// DIRECTIVES
import {IsPositiveIntegerValidator} from './directives/is-positive-integer-validator';
// MODULES
import {AppConfirmModule} from './services/app-confirm/app-confirm.module';
import {SpinnerComponent} from './components/spinner/spinner.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCommonModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatSortModule,
    MatListModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatTabsModule,
    MatTooltipModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatGridListModule,
    AppConfirmModule
  ],
  declarations: [
    BySiteTypeComponent,
    FrontendVersionComponent,
    BackendVersionComponent,
    IsPositiveIntegerValidator,
    SpinnerComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MatCommonModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatExpansionModule,
    MatSortModule,
    MatListModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatTabsModule,
    MatTooltipModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatGridListModule,
    BySiteTypeComponent,
    FrontendVersionComponent,
    BackendVersionComponent,
    SpinnerComponent
  ],
})

export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts